var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-list" },
    [
      _vm.hasFilters
        ? _c("ui-button", {
            staticClass: "media-list__filters__reset-button",
            attrs: {
              floating: "",
              icon: "fal fa-times",
              primary: "",
              tooltip: "Reset all filters",
            },
            on: { click: _vm.resetFilters },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.mediaList.length > 0
        ? _c(
            "div",
            { staticClass: "media-list__filters ui-elevation-1 panel" },
            [
              _c("ui-input", {
                attrs: { clearable: "", label: "Filter text" },
                model: {
                  value: _vm.textFilter,
                  callback: function ($$v) {
                    _vm.textFilter = $$v
                  },
                  expression: "textFilter",
                },
              }),
              _vm._v(" "),
              _c("ui-datepicker", {
                ref: "startDatepicker",
                staticClass: "media-list__filters__date",
                attrs: { "close-on-select": "", label: "From" },
                model: {
                  value: _vm.selectedStartDate,
                  callback: function ($$v) {
                    _vm.selectedStartDate = $$v
                  },
                  expression: "selectedStartDate",
                },
              }),
              _vm._v(" "),
              _c("ui-datepicker", {
                ref: "endDatepicker",
                staticClass: "media-list__filters__date",
                attrs: { "close-on-select": "", label: "To" },
                model: {
                  value: _vm.selectedEndDate,
                  callback: function ($$v) {
                    _vm.selectedEndDate = $$v
                  },
                  expression: "selectedEndDate",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "media-list__filters__sort" },
                [
                  _c(
                    "ui-select",
                    {
                      staticClass: "media-list__filters__sort__select",
                      attrs: { label: "Sort by" },
                      model: {
                        value: _vm.sortBy,
                        callback: function ($$v) {
                          _vm.sortBy = $$v
                        },
                        expression: "sortBy",
                      },
                    },
                    [
                      _c("ui-select-item", {
                        attrs: { label: "Date", value: "created" },
                      }),
                      _vm._v(" "),
                      _c("ui-select-item", {
                        attrs: { label: "Duration", value: "duration" },
                      }),
                      _vm._v(" "),
                      _c("ui-select-item", {
                        attrs: { label: "Size", value: "size" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ui-button", {
                    attrs: {
                      icon:
                        "fal " +
                        (_vm.sortDirection === "asc"
                          ? "fa-long-arrow-down"
                          : "fa-long-arrow-up"),
                      tooltip: "Sort direction",
                    },
                    on: {
                      click: function ($event) {
                        _vm.sortDirection === "asc"
                          ? (_vm.sortDirection = "desc")
                          : (_vm.sortDirection = "asc")
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ui-select",
                {
                  staticClass: "media-list__filters__tag-list",
                  attrs: {
                    disabled: _vm.tagList.length === 0,
                    label: "Tags",
                    multiple: "",
                  },
                  model: {
                    value: _vm.selectedTagList,
                    callback: function ($$v) {
                      _vm.selectedTagList = $$v
                    },
                    expression: "selectedTagList",
                  },
                },
                _vm._l(_vm.tagList, function (tag) {
                  return _c("ui-select-item", {
                    key: tag,
                    attrs: { label: tag, value: tag },
                    nativeOn: {
                      click: function ($event) {
                        _vm.mediaItemsChunkLimit = _vm.mediaItemsChunkSize
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "ui-select",
                {
                  staticClass: "media-list__filters__participant-list",
                  attrs: {
                    disabled: _vm.participantList.length === 0,
                    label: "Participants",
                    multiple: "",
                  },
                  model: {
                    value: _vm.selectedParticipantList,
                    callback: function ($$v) {
                      _vm.selectedParticipantList = $$v
                    },
                    expression: "selectedParticipantList",
                  },
                },
                _vm._l(_vm.participantList, function (participant) {
                  return _c("ui-select-item", {
                    key: participant,
                    attrs: { label: participant, value: participant },
                    nativeOn: {
                      click: function ($event) {
                        _vm.mediaItemsChunkLimit = _vm.mediaItemsChunkSize
                      },
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedItems.length > 0
        ? _c("ui-button", {
            staticClass:
              "media-list__action-button media-list__action-button--delete",
            attrs: {
              floating: "",
              icon: "fal fa-trash",
              primary: "",
              tooltip: "Delete selected videos",
            },
            on: { click: _vm.$refs.confirmBatchDeleteDialog.open },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedItems.length > 0
        ? _c("ui-button", {
            staticClass:
              "media-list__action-button media-list__action-button--deselect",
            attrs: {
              floating: "",
              icon: "fal fa-check",
              primary: "",
              tooltip: "Deselect all videos",
            },
            on: { click: _vm.deselectAllMedia },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && !_vm.isFetching && _vm.mediaList.length === 0
        ? _c("ui-empty-state", {
            attrs: {
              description: "Recorded videos will show in this list",
              icon: "fas fa-images",
              label: "No recorded videos",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-list__items" },
        _vm._l(_vm.chunkedMediaList, function (mediaItem, index) {
          return _c("media-list-item", {
            key: mediaItem.media_id,
            ref: mediaItem.media_id,
            refInFor: true,
            attrs: {
              "media-item": mediaItem,
              "recorder-api-url": _vm.recorderApiUrl,
            },
            on: {
              confirmDeleteMedia: _vm.confirmDeleteMedia,
              playMedia: _vm.playMedia,
              remove: function ($event) {
                return _vm.mediaList.splice(index, 1)
              },
              shareMedia: _vm.shareMedia,
              trimMedia: _vm.trimMedia,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      !_vm.initialized && _vm.isFetching
        ? _c(
            "div",
            { staticClass: "media-list__loading" },
            [_c("ui-progress", { attrs: { type: "dots" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ui-dialog",
        {
          ref: "confirmBatchDeleteDialog",
          attrs: {
            title:
              "Permanently delete selected " +
              _vm.$options.filters.pluralize(
                _vm.selectedItems.length,
                "video"
              ) +
              "?",
            closable: "",
          },
        },
        [
          _c("p", [
            _vm._v(
              "You are about to delete " +
                _vm._s(_vm.selectedItems.length) +
                " selected " +
                _vm._s(_vm._f("pluralize")(_vm.selectedItems.length, "video")) +
                ", this action is permanent and cannot be undone."
            ),
          ]),
          _vm._v(" "),
          _c(
            "ui-dialog-footer",
            [
              _c("ui-button", {
                attrs: { text: "Cancel", tooltip: "Abort deletion" },
                on: {
                  click: function ($event) {
                    return _vm.$refs.confirmBatchDeleteDialog.close()
                  },
                },
              }),
              _vm._v(" "),
              _c("ui-button", {
                attrs: {
                  tooltip:
                    "Permanently delete selected " +
                    _vm.$options.filters.pluralize(
                      _vm.selectedItems.length,
                      "video"
                    ),
                  secondary: "",
                  text: "Delete",
                },
                on: { click: _vm.batchDeleteMedia },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ui-dialog",
        {
          ref: "confirmDeleteDialog",
          attrs: { closable: "", title: "Permanently delete video?" },
        },
        [
          _c("p", [
            _vm._v("You are about to delete the video "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.deleteMediaItem
                    ? _vm.deleteMediaItem.comment || _vm.deleteMediaItem.title
                    : ""
                )
              ),
            ]),
            _vm._v(", this action is permanent and cannot be undone."),
          ]),
          _vm._v(" "),
          _c(
            "ui-dialog-footer",
            [
              _c("ui-button", {
                attrs: { text: "Cancel", tooltip: "Abort deletion" },
                on: {
                  click: function ($event) {
                    return _vm.$refs.confirmDeleteDialog.close()
                  },
                },
              }),
              _vm._v(" "),
              _c("ui-button", {
                attrs: {
                  secondary: "",
                  text: "Delete",
                  tooltip: "Permanently delete video",
                },
                on: { click: _vm.deleteMedia },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("editor-dialog", { ref: "editorDialog" }),
      _vm._v(" "),
      _c("share-dialog", { ref: "shareDialog" }),
      _vm._v(" "),
      _c("web-player-dialog", {
        ref: "webPlayerDialog",
        on: { trimMedia: _vm.trimMedia },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }